import { GraphQLClient } from 'graphql-request';

import { environment } from '../../environment';

import { filUploadRequestMiddleware } from '../middlewares/file-upload-request-middleware.util';

export const fileUploadClient = new GraphQLClient(
  `${environment.backendUrl}${environment.graphQLEndpoint}`,
  {
    mode: 'cors',
    credentials: 'include',
    requestMiddleware: filUploadRequestMiddleware,
  },
);
